/// <amd-module name="Repos/Views/Settings/Repositories/RestClient/Git" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\views\settings\repositories\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Git from "Repos/Common/Contracts/Git";

export interface IGitRestClient extends IVssRestClient {
    /**
     * Delete a git repository
     * 
     * @param repositoryId - The ID of the repository.
     * @param project - Project ID or project name
     */
    deleteRepository(repositoryId: string, project?: string): Promise<void>;
    /**
     * Retrieve git repositories.
     * 
     * @param project - Project ID or project name
     * @param includeLinks - [optional] True to include reference links. The default value is false.
     * @param includeAllUrls - [optional] True to include all remote URLs. The default value is false.
     * @param includeHidden - [optional] True to include hidden repositories. The default value is false.
     */
    getRepositories(project?: string, includeLinks?: boolean, includeAllUrls?: boolean, includeHidden?: boolean): Promise<Git.GitRepository[]>;
    /**
     * Updates the Git repository with either a new repo name or a new default branch.
     * 
     * @param newRepositoryInfo - Specify a new repo name or a new default branch of the repository
     * @param repositoryId - The ID of the repository.
     * @param project - Project ID or project name
     */
    updateRepository(newRepositoryInfo: Git.GitRepository, repositoryId: string, project?: string): Promise<Git.GitRepository>;
}

class GitRestClient extends RestClientBase implements IGitRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Delete a git repository
     * 
     * @param repositoryId - The ID of the repository.
     * @param project - Project ID or project name
     */
    public async deleteRepository(
        repositoryId: string,
        project?: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/git/Repositories/{repositoryId}",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            }
        });
    }

    /**
     * Retrieve git repositories.
     * 
     * @param project - Project ID or project name
     * @param includeLinks - [optional] True to include reference links. The default value is false.
     * @param includeAllUrls - [optional] True to include all remote URLs. The default value is false.
     * @param includeHidden - [optional] True to include hidden repositories. The default value is false.
     */
    public async getRepositories(
        project?: string,
        includeLinks?: boolean,
        includeAllUrls?: boolean,
        includeHidden?: boolean
        ): Promise<Git.GitRepository[]> {

        const queryValues: any = {
            includeLinks: includeLinks,
            includeAllUrls: includeAllUrls,
            includeHidden: includeHidden
        };

        return this.beginRequest<Git.GitRepository[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/Repositories/{repositoryId}",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * Updates the Git repository with either a new repo name or a new default branch.
     * 
     * @param newRepositoryInfo - Specify a new repo name or a new default branch of the repository
     * @param repositoryId - The ID of the repository.
     * @param project - Project ID or project name
     */
    public async updateRepository(
        newRepositoryInfo: Git.GitRepository,
        repositoryId: string,
        project?: string
        ): Promise<Git.GitRepository> {

        return this.beginRequest<Git.GitRepository>({
            apiVersion: "5.0-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/git/Repositories/{repositoryId}",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            body: newRepositoryInfo
        });
    }

}

export const GitClientName = "Repos.Settings.Git.IGitRestClient";

export function getGitClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGitRestClient {
    return pageContext.getRestClient<IGitRestClient>(GitClientName, options);
}

RestClients.add(GitClientName, { 
    factory: GitRestClient,
    options: {
        resourceAreaId: "4e080c62-fa21-4fbc-8fef-2a10a2b38049",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
